import api from "../../axiosInstance";
import type {
  EventsResponse,
  GetEventsParams,
  EventDetailResponse,
  ScheduleDetailResponse,
  SeatsResponse,
  EventCouponsResponse,
} from "./types";

export const eventsService = {
  getEvents: async (params?: GetEventsParams): Promise<EventsResponse> => {
    const response = await api.get<EventsResponse>("/user/events", {
      params: {
        page: params?.page ?? 1,
        limit: params?.limit ?? 10,
        status: params?.status,
        search: params?.search,
        tags: params?.tags,
        excludeTags: params?.excludeTags,
        dateFrom: params?.dateFrom,
        dateTo: params?.dateTo,
      },
    });
    return response.data;
  },

  getEventById: async (id: string): Promise<EventDetailResponse> => {
    const response = await api.get<EventDetailResponse>(
      `/user/events/events/${id}`
    );
    return response.data;
  },

  getEventCoupons: async (id: string): Promise<EventCouponsResponse> => {
    const response = await api.get<EventCouponsResponse>(
      `/user/events/events/${id}/coupons`
    );
    return response.data;
  },

  getScheduleById: async (id: string): Promise<ScheduleDetailResponse> => {
    const response = await api.get<ScheduleDetailResponse>(
      `/user/events/schedules/${id}`
    );
    return response.data;
  },

  getScheduleMapSvg: async (scheduleId: string): Promise<string> => {
    const response = await api.get<string>(
      `/user/events/schedules/${scheduleId}/map`,
      {
        headers: {
          Accept: "image/svg+xml",
        },
        responseType: "text",
      }
    );
    return response.data;
  },

  getScheduleSeats: async (scheduleId: string): Promise<SeatsResponse> => {
    const response = await api.get<SeatsResponse>(
      `/user/events/schedules/${scheduleId}/seats`
    );
    return response.data;
  },
};

export default eventsService;
